import AddActionTitleWrapper from './AddActionTitleWrapper';

export default AddActionTitleWrapper;
